/**
 * Bookable services – shared between ServicesPage and BookingSystem.
 * جلسات الشرح والمناقشة : morning 150, evening 200.
 * Other services use same price for morning and evening unless specified.
 */
export const BOOKABLE_SERVICES = [
  {
    id: 'phone',
    name: 'الاستشارة الهاتفية السريعة',
    description: 'جلسة مركزة وسريعة عبر الهاتف للإجابة على استفساراتك المحددة وتوجيهك للطريق الصحيح. مثالية للطالبة التي تحتاج "رأي خبير" في نقطة محددة.',
    duration: '30 دقيقة',
    price: 89,
    eveningPrice: 89,
    features: ['مخصصة للبنات فقط', 'حل فوري لمشكلة عالقة'],
  },
  {
    id: 'zoom',
    name: 'جلسات الشرح والمناقشة ',
    description: 'جلسة تفاعلية مرئية نغوص فيها في عمق بحثك. سواء كنتِ تبحثين عن عنوان، أو تريدين فهم الثغرات وكيفية تعديلها بنفسك.',
    duration: '60 دقيقة',
    morningPrice: 150,
    eveningPrice: 200,
    features: ['شرح مباشر للثغرات', 'اقتراح عناوين دراسات جديدة', 'تسجيل الجلسة متاح للمراجعة'],
    featured: true,
  },
  {
    id: 'defense',
    name: 'التدريب على المناقشة (المحاكاة)',
    description: 'بروفة حقيقية ليوم المناقشة. أقرأ الأجزاء المحورية في بحثك، وأجهز لكِ الأسئلة المتوقعة، وأمارس عليكِ "الضغط العلمي" لتكسري حاجز الخوف وتدافعي عن بحثك بثقة.',
    duration: 'ساعة مكثفة',
    price: 350,
    eveningPrice: 350,
    features: ['محاكاة أجواء المناقشة الواقعية', 'تعزيز الثقة وسرعة البديهة'],
  },
];

/** Get service by id. Returns Zoom as default if not found. */
export function getServiceById(id) {
  const found = BOOKABLE_SERVICES.find((s) => s.id === id);
  return found || BOOKABLE_SERVICES.find((s) => s.id === 'zoom');
}

/** Default service when user opens /booking directly (e.g. Zoom). */
export function getDefaultBookingService() {
  return BOOKABLE_SERVICES.find((s) => s.id === 'zoom');
}
